export const getAiBorderMode = _ref => {
  let {
    isAnalyzing,
    isDeciding,
    isRecommendedCard
  } = _ref;
  if (isDeciding) {
    return isRecommendedCard ? 'grow' : 'fade';
  }
  return isAnalyzing ? 'travel' : 'off';
};
//# sourceMappingURL=getAiBorderMode.js.map